import React from 'react'
import Reflux from 'reflux'
import { Badge } from 'reactstrap'
import _ from 'lodash'

import CategoriesStore from '~/stores/categories.js'


export default class CategoryLabel extends Reflux.Component {
	constructor(props) {
		super(props)

		this.stores = [CategoriesStore]
		this.storeKeys = ['categories']

		this.state = {
			categories: []
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const isCategoriesLoaded = (_.size(this.state.categories) > 0 && typeof this.props.categoryID !== 'undefined')
		const theCategory = (isCategoriesLoaded)
			? _.find(this.state.categories, { categoryID: this.props.categoryID })
			: null

		return (isCategoriesLoaded)
			? <Badge color="dark">{ theCategory.category }</Badge>
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/categoryLabel/index.jsx